import React from 'react';
import { SectionEyebrow } from './SectionEyebrow';
import { stages } from '../data/coachSystem';
export function SystemSection() {
  return <section className="bg-char py-11 sm:py-14" aria-labelledby="system-title" data-id="element-110" data-mp="3girfb9ody9ya">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-5xl" data-id="element-111" data-mp="3bhll17f2uemn">
        <SectionEyebrow label="A more organized way to coach" data-id="element-112" data-mp="36iqutkes5nsi" />

        <h2 id="system-title" className="mt-4 font-display text-[1.8rem] font-semibold uppercase leading-[1.1] tracking-tight text-ivory sm:text-[2.3rem]" data-id="element-113" data-mp="31kgxb35l2b3q">
          Coaching basketball takes more than collecting random drills.
        </h2>

        <div className="mx-auto mt-5 max-w-2xl space-y-3.5" data-id="element-114" data-mp="2sqayt3kaqq13">
          <p className="text-[0.98rem] leading-relaxed text-ivory-muted" data-id="element-115" data-mp="2nudg4qlk97l5">
            Practices need structure. Skills need progression. Offense and
            defense need organization. Players need development. Game days need
            preparation.
          </p>
          <p className="text-[0.98rem] leading-relaxed text-ivory-muted" data-id="element-116" data-mp="13zhph2l2v3y9">
            Organizing all of that across scattered notes, saved drills,
            videos, documents and disconnected resources is what consumes the
            time. Basketball Coach System™ brings the essential pieces
            together into one organized professional coaching library.
          </p>
        </div>

        <ol className="mx-auto mt-8 max-w-4xl space-y-2 sm:grid sm:grid-cols-3 sm:gap-x-5 sm:space-y-0" data-id="element-117" data-mp="1mpz4k4czm115">
          {stages.map((stage, index) => <li key={stage.label} className="flex items-start gap-4 rounded-lg border-l-2 border-orange/30 bg-char-light px-4 py-4 text-left shadow-card sm:flex-col sm:items-center sm:gap-0 sm:border-l-0 sm:border-t-2 sm:py-5 sm:text-center" data-id="element-118" data-mp="1roae0dzde9iu" data-mpi={index}>
              <span className="font-display text-[1.65rem] font-semibold leading-none text-orange sm:text-[1.85rem]" data-id="element-119" data-mp="1bbl0ss8swtp">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="sm:mt-2.5" data-id="element-120" data-mp="28x369cvla22r">
                <h3 className="font-display text-[1.05rem] font-semibold uppercase leading-none tracking-[0.14em] text-ivory" data-id="element-121" data-mp="2907gorzndu1v">
                  {stage.label}
                </h3>
                <p className="mt-1.5 max-w-xs text-[0.9rem] leading-relaxed text-ivory-muted" data-id="element-122" data-mp="1z6qplvqwat1w">
                  {stage.description}
                </p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-7 max-w-lg font-display text-[1.05rem] font-semibold uppercase tracking-[0.14em] text-ivory sm:text-[1.2rem]" data-id="element-123" data-mp="1p814zv7m6uhy">
          Open{' '}
          <span className="text-orange" aria-hidden="true" data-id="element-124" data-mp="1gaifadj0zrzq">
            •
          </span>{' '}
          Choose{' '}
          <span className="text-orange" aria-hidden="true" data-id="element-125" data-mp="1bbxfugbllccc">
            •
          </span>{' '}
          Coach
        </p>
        <p className="mx-auto mt-2 max-w-md text-[0.92rem] leading-relaxed text-ivory-muted" data-id="element-126" data-mp="3al496oem8mc4">
          Open the system. Choose what your team needs. Take it to the court.
        </p>
      </div>
    </section>;
}